import { AccountPanel, autoId } from '@workday/upc-common';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SETTINGS_PATH } from '../react-router-paths';
import styles from './wcl-account-panel.module.scss';
import { ID_MANAGE_ACCOUNT, ID_SIGN_OUT } from '../autoIds';
import { useSelector } from 'react-redux';
import { selectProfileImageUrl } from '../slices/profile-image.slice';
import { TranslatedExternalLink } from '../shared/translated-external-link';

export const USER_PROFILE_PHOTO_ALT = 'User Profile';

interface WclAccountPanelProps {
    username: string;
    email: string;
    closeMenu: () => void;
    onSignOutClick: () => void;
}
export function WclAccountPanel({ username, email, onSignOutClick, closeMenu }: WclAccountPanelProps) {
    const { t } = useTranslation('account');

    const profileImageUrl = useSelector(selectProfileImageUrl);

    return (
        <AccountPanel>
            <AccountPanel.Avatar url={profileImageUrl} altText={USER_PROFILE_PHOTO_ALT} />
            <AccountPanel.Username>{username}</AccountPanel.Username>
            <AccountPanel.Email>{email}</AccountPanel.Email>
            <Link className={styles.settingsLink} to={SETTINGS_PATH} {...autoId(ID_MANAGE_ACCOUNT)} onClick={closeMenu}>
                {t('AccountInfo.manageAccount')}
            </Link>
            <AccountPanel.SignOutButton onClick={onSignOutClick} {...autoId(ID_SIGN_OUT)}>
                {t('AccountInfo.manageSignOut')}
            </AccountPanel.SignOutButton>
            <AccountPanel.Footer>
                <TranslatedExternalLink translationKey='privacyUrl' className={styles.footerLink}>
                    {t('AccountInfo.managePrivacyStatement')}
                </TranslatedExternalLink>
                <div className={styles.separator}></div>
                <TranslatedExternalLink translationKey='termsUrl' className={styles.footerLink}>
                    {t('AccountInfo.manageTermsOfUse')}
                </TranslatedExternalLink>
            </AccountPanel.Footer>
        </AccountPanel>
    );
}
